<template>
    <div class="c-grid-cars-controls__wrap">
        <div class="o-container -full">
            <div class="c-grid-cars-controls">
                <div class="c-grid-cars-controls__left">
                    <div class="c-grid-cars-filter-closed">
                        <button class="o-button-filters-toggle" @click="$root.sidebarActive = !$root.sidebarActive">
                            <svgIco icon="cars-filters" />
                            Filtrer
                        </button>
                        <!-- <div class="c-grid-cars-controls__list">
                            <button v-for="item in $root.filters.inventory" :key="item.value"
                                class="o-button-cars-control" :class="{'is-active': item.selected}"
                                @click="item.selected = !item.selected">
                                {{ item.label }}
                            </button>
                        </div> -->
                        <div class="c-grid-cars-filter__select">
                            <button class="c-grid-cars-filter-order o-button -button-unstyled" @click="$root.rev = !$root.rev" :class="{'is-reverse': $root.rev}">
                                <svgIco icon="cars-orderby" />
                                Trier&nbsp;par
                            </button>
                            <div class="o-fake-select__wrap">
                                <div class="o-select__wrap">
                                    <select class="o-select -sort-by" v-model="$root.sort">
                                        <option data-width="lg" value="issitemake" selected>date d'arrivage</option>
                                        <option data-width="md" value="kms">Kilométrage</option>
                                        <option data-width="sm" value="year">Année</option>
                                        <option data-width="xs" value="price">Prix</option>
                                    </select>
                                </div>
                                <div class="o-fake-select">
                                    <div class="o-fake-select__label">
                                        {{ selectedLabel }}
                                    </div>
                                    <div class="o-fake-select__options">
                                        <div data-label="date d'arrivage" class="o-fake-select__option" @click="updateLabel('date d\'arrivage', 'issitemake')">
                                            date d'arrivage
                                        </div>
                                        <div data-label="Kilométrage" class="o-fake-select__option" @click="updateLabel('Kilométrage', 'kms')">
                                            Kilométrage
                                        </div>
                                        <div data-label="Année" class="o-fake-select__option" @click="updateLabel('Année', 'year')">
                                            Année
                                        </div>
                                        <div data-label="Prix" class="o-fake-select__option" @click="updateLabel('Prix', 'price')">
                                            Prix
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="c-grid-cars-filter-open">
                        <button class="o-button-cars-filter -close" @click="$root.sidebarActive = !$root.sidebarActive">
                            <svgIco icon="close" />
                        </button>
                        
                        <div class="c-grid-cars-filter__select -hidden-desktop">
                            <button class="c-grid-cars-filter-order o-button -button-unstyled" @click="$root.rev = !$root.rev" :class="{'is-reverse': $root.rev}">
                                <svgIco icon="cars-orderby" />
                                Trier&nbsp;par
                            </button>
                            <div class="o-fake-select__wrap">
                                <div class="o-select__wrap">
                                    <select class="o-select -sort-by" v-model="$root.sort">
                                        <option data-width="lg" value="issitemake" selected>date d'arrivage</option>
                                        <option data-width="md" value="kms">Kilométrage</option>
                                        <option data-width="sm" value="year">Année</option>
                                        <option data-width="xs" value="price">Prix</option>
                                    </select>
                                </div>
                                <div class="o-fake-select">
                                    <div class="o-fake-select__label">
                                        {{ selectedLabel }}
                                    </div>
                                    <div class="o-fake-select__options">
                                        <div data-label="date d'arrivage" class="o-fake-select__option" @click="updateLabel('date d\'arrivage', 'issitemake')">
                                            date d'arrivage
                                        </div>
                                        <div data-label="Kilométrage" class="o-fake-select__option" @click="updateLabel('Kilométrage', 'kms')">
                                            Kilométrage
                                        </div>
                                        <div data-label="Année" class="o-fake-select__option" @click="updateLabel('Année', 'year')">
                                            Année
                                        </div>
                                        <div data-label="Prix" class="o-fake-select__option" @click="updateLabel('Prix', 'price')">
                                            Prix
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="c-grid-cars-controls__right">
                    <span class="c-grid-cars-controls__filters -units">
                        {{ $root.total }} unités
                    </span>
                    <div class="c-grid-cars-controls__keywords">

                        <span class="o-button-cars-filter" v-for="item in $root.selectedMakes" :key="item.value">
                            {{ item.label }}
                            <button @click="item.selected = false">
                                <svgIco icon="close" />
                            </button>
                        </span>
                        <span class="o-button-cars-filter" v-for="item in $root.selectedModels" :key="item.value">
                            {{ item.label }}
                            <button @click="item.selected = false">
                                <svgIco icon="close" />
                            </button>
                        </span>
                        <span class="o-button-cars-filter" v-for="item in $root.selectedTypes" :key="item.value">
                            {{ item.label }}
                            <button @click="item.selected = false">
                                <svgIco icon="close" />
                            </button>
                        </span>
                    </div>
                    <button class="c-button-cars-filter-reset o-button" @click="$root.resetFilters()">
                        <svgIco icon="trash" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'Controls',
    
    data() {
        return {
            selectedLabel: "date d'arrivage"
        };
    },
    computed: {

    },
    methods: {
        updateLabel(label, sortValue) {
            this.selectedLabel = label;
            this.$root.sort = sortValue;
            if (document.activeElement) {
                document.activeElement.blur();
            }
        }
    }
}
</script> 